(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('recipient-form-fields', class extends baseComponent.default {
        elements = {
            fieldRefs: '*[data-field-ref]',
            fieldsTrigger: '[data-fields-trigger]'
        }

        render() {
            this.$fieldsTrigger.addEventListener('change', this._handleTriggerChange.bind(this));
            this.querySelector('[name="properties[__shopify_offset]"]').value = new Date().getTimezoneOffset().toString();

           if(this.querySelector('[name="properties[Send on]"]')){
              var dtToday = new Date();
    
              var month = dtToday.getMonth() + 1;
              var day = dtToday.getDate();
              var year = dtToday.getFullYear();
              if(month < 10)
                  month = '0' + month.toString();
              if(day < 10)
                  day = '0' + day.toString();
              
              var maxDate = year + '-' + month + '-' + day;

              this.querySelector('[name="properties[Send on]"]').setAttribute('min', maxDate);
           }
        }

        _handleTriggerChange({ target }) {
            this._toggleFieldsDisable(!target.checked);
        }

        _toggleFieldsDisable(state) {
            this.$fieldRefs.map(field => field.disabled = state);
        }
    });
})();
